console.log('VERSION CHECK: INDEX.JS v3.0 - LATEST CODE');
console.log('VERSION CHECK: TIMESTAMP', new Date().toISOString());

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { GoogleOAuthProvider } from '@react-oauth/google';
import './i18n'; // Initialize i18n
import { MediaCacheProvider } from './contexts/MediaCacheContext'; // Phase 3 caching

// Suppress browser extension errors (MetaMask, etc.)
window.addEventListener('error', (event) => {
  // Check if error is from a browser extension
  if (event.error && event.error.stack && 
      (event.error.stack.includes('chrome-extension://') || 
       event.error.stack.includes('moz-extension://'))) {
    event.preventDefault();
    event.stopPropagation();
    console.warn('Browser extension error suppressed:', event.error.message);
    return true;
  }
});

console.log('🟣🟣🟣 INDEX.JS EXECUTING - About to render app');
console.log('🟣🟣🟣 MediaCacheProvider:', typeof MediaCacheProvider);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <MediaCacheProvider>
        <App />
      </MediaCacheProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);

console.log('🟣🟣🟣 INDEX.JS - App render initiated');
